import type { I18nFn } from '#/i18n/types/I18nFn';

import { LISTING_TYPE_PLURAL_HUMAN_NAME_MAP } from './listingTypePluralHumanNameMap';

export function OBJECT_TYPE_PLURAL_HUMAN_NAME_MAP(i18n: I18nFn) {
  return {
    ...LISTING_TYPE_PLURAL_HUMAN_NAME_MAP(i18n),
    ARTICLE: i18n('articles'),
    CANDIDATE: i18n('candidates'),
    USER: i18n('users'),
    INVOICE: i18n('invoices'),
    PAYMENT: i18n('payments'),
    DONATION: i18n('donations'),
  };
}
